import { orchestrator } from 'satcheljs';
import { clearLocalStorageProtected } from '../../utils';
import { onUserContextChanged } from '../actions';
import { getAppStore, StorageUserContextKey } from '../store/store';

orchestrator(onUserContextChanged, async (msg) => {
  const store = getAppStore();
  if (!store.userContext) {
    clearLocalStorageProtected();
  } else {
    localStorage.setItem(StorageUserContextKey, JSON.stringify(msg.userDetails));
  }
});
